import { z } from 'zod';
/**
 * UTM params captured at sign-up. All fields are optional and may be null
 * when the user landed without UTM tagging.
 */
export const UTMParamsSchema = z.object({
    utm_source: z.string().nullable().optional(),
    utm_medium: z.string().nullable().optional(),
    utm_campaign: z.string().nullable().optional(),
    utm_content: z.string().nullable().optional(),
    utm_term: z.string().nullable().optional(),
});
/**
 * POST /auth/google/callback request body.
 */
export const GoogleCallbackRequestSchema = z.object({
    code: z.string().min(1),
    utm_params: UTMParamsSchema.optional(),
});
/**
 * Cognito-issued tokens. Snake_case to match what Cognito's token endpoint
 * returns and what the backend forwards verbatim — the frontend normalizes
 * to camelCase when storing in localStorage.
 */
export const CognitoTokensSchema = z.object({
    access_token: z.string(),
    id_token: z.string(),
    refresh_token: z.string(),
    expires_in: z.number(),
});
/**
 * POST /auth/google/refresh response body (200 case).
 *
 * Cognito's REFRESH_TOKEN_AUTH flow does NOT reissue a refresh token, so this
 * deliberately omits refresh_token — the caller keeps reusing the one it has.
 */
export const RefreshResponseSchema = z.object({
    access_token: z.string(),
    id_token: z.string(),
    expires_in: z.number(),
});
/**
 * User profile claims as returned by /auth/google/callback. Sub is the
 * Cognito subject — stable identifier suitable for use as GA4 user_id.
 */
export const AuthUserSchema = z.object({
    email: z.string().email(),
    name: z.string(),
    picture: z.string(),
    sub: z.string(),
});
/**
 * POST /auth/google/callback response body (200 case).
 */
export const GoogleCallbackResponseSchema = z.object({
    tokens: CognitoTokensSchema,
    user: AuthUserSchema,
});
